/**
 * Article metadata for the knowledge base.
 *
 * Discovered automatically by `generate-kb-catalog.mjs` (runs on `yarn start` and
 * `yarn build`). The slug must match this folder name.
 */
export const meta = {
  slug: 'error-tracking',
  title: 'Error tracking',
  category: 'Error tracking',
  summary:
    'How PulseWatch collects errors from your applications, groups them into issues, and how to triage them with resolve, ignore and delete.',
  keywords: ['error tracking', 'exceptions', 'issues', 'ingest key', 'resolve', 'ignore', 'regression', 'retention'],
};

export const loadComponent = () => import('./error-tracking.component').then((m) => m.ErrorTrackingArticleComponent);
